module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/title-top@2x_1d8b73d0e21fd79fff6bc800cb330287.png";